<footer class="bottom-section-wrap">
  <div class="footer-content">
    <h1>Atendimento</h1>
    <h2>SEG A SÁB | 8h às 17h</h2>
    <app-contact-icons-block></app-contact-icons-block>
    <app-bottom-copyright style="display: block; margin-top: 1.1rem;margin-bottom: 1.1rem"></app-bottom-copyright>
  </div>
</footer>
